module.exports = __webpack_public_path__ + "static/media/EnvPromo-RedTree_02.86b4a14e.jpg";